import { ContentService } from '@blk/cwp-ng-framework';
import { Alignment, ParagraphComposer, ReportPageTemplate, ReportSection, SVG_NS, SvgParser } from '@blk/simba';
import { ComponentData } from '@ddt-web/data-service';

import { CustomContentBox } from './custom-content-box.interface';

export abstract class StaticContentSection extends ReportSection {
	public name: string;
	public type: string;
	public customContentBox: SVGGElement;

	constructor(name: string = 'DefaultPsCoverComponentName', order?: number, isVisible?: boolean) {
		super([], name, order, isVisible);
	}

	public getResult(): SVGSVGElement {
		const parser: SvgParser = new SvgParser();
		const svg: SVGSVGElement = <SVGSVGElement>parser.parseSVG(this.getStaticContent());
		if (this.customContentBox) {
			svg.appendChild(this.customContentBox);
		}

		if (svg.tagName !== 'svg') {
			throw new Error('Static content needs to produce a valid <SVG> element');
		}
		return svg;
	}

	public generateParagraphBox(paraText: string, contentBoxAttributes: CustomContentBox, textAttributes: { [key: string]: string | number }, lineHeight?: number): void {
		const composer = new ParagraphComposer();
		const paragraphSection = composer.compose(paraText, textAttributes, Alignment.Horizontal.Left, contentBoxAttributes.width, 100, true, 10); // sending static height as its not used in the method

		// if height not provided, dynamically generate based on number of child lines
		if (!contentBoxAttributes.height) {
			const numOfLines = paragraphSection?.[0].element.childNodes.length;
			contentBoxAttributes.height = numOfLines * lineHeight;
		}

		// update yOffset based on if its the base yOffset 
		if (contentBoxAttributes.isBaseYOffset) {
			contentBoxAttributes.yOffset = contentBoxAttributes.yOffset - contentBoxAttributes.height;
		}
		this.customContentBox = this.createCustomContentArea(contentBoxAttributes);

		this.customContentBox.appendChild(paragraphSection[0].element);
	}

	private createCustomContentArea(contentBoxAttributes: CustomContentBox): SVGGElement {
		const contentArea: SVGGElement = <SVGGElement>document.createElementNS(SVG_NS, 'g');
		contentArea.setAttribute('id', `customContentArea`);
		contentArea.setAttribute(
			'transform',
			`translate(${contentBoxAttributes.xOffset}, ${contentBoxAttributes.yOffset})`
		);
		contentArea.setAttribute('width', `${contentBoxAttributes.width}px`);
		contentArea.setAttribute('height', `${contentBoxAttributes.height}px`);
		return contentArea;

	}

	public generate(componentDataMap: Map<string, ComponentData>, contentSvc: ContentService, pageTemplate: ReportPageTemplate): Array<SVGSVGElement> {
		return [this.getResult()];
	}

	protected abstract getStaticContent(): string;
}
